module.exports = __webpack_public_path__ + "static/media/refer.69cd6092.svg";